export default __webpack_public_path__ + "static/media/building-color.b76da2af.svg";